export const calculatePerPayslipPrice = (
  planPrice = 0,
  planType = "Monthly",
  planUnits = 1,
) => {
  if (!planPrice || planPrice <= 0) return 0;

  const totalPayslips = planType === "Yearly" ? planUnits * 12 : planUnits;

  if (!totalPayslips || totalPayslips <= 0) return 0;

  return (planPrice / totalPayslips).toFixed(2);
};

// ========== new

export const calculatePerEmployeePrice = (planPrice = 0, maxEmployees = 1) => {
  if (!planPrice || planPrice <= 0) return 0;
  if (!maxEmployees || maxEmployees <= 0) return 0;

  return Number(planPrice / maxEmployees).toFixed(2);
};
